"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingFilters = void 0;
const form_hooks_1 = require("@hooks/form.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const button_1 = require("@shared-modules/components/button");
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const RatingFilters = (props) => {
    const { onFiltersChange } = props;
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const translator = (0, translation_hooks_1.usePagesTranslation)("ratingPage.ratingFilters");
    const { form, fieldHandlers } = (0, form_hooks_1.useForm)({
        initialData: helper_1.DEFAULT_FILTER_FORM,
        onUpdate: (form) => {
            onFiltersChange(form);
        },
    });
    return (react_1.default.createElement("div", { className: "c-rating-page-rating-filter" },
        react_1.default.createElement("div", { className: "c-rating-page-rating-filter__periods" }, (0, helper_1.getPeriodsOptions)(commonTranslator, translator).map(({ label, value }) => {
            return (react_1.default.createElement(button_1.Button, { onClick: () => fieldHandlers.period(value), size: "small", type: form.period === value ? "primary" : "thirtery", className: "c-rating-page-rating-filter__periods-item", key: value || "all" }, label));
        }))));
};
exports.RatingFilters = RatingFilters;
